
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/java",
      function () {
        return require("private-next-pages/java.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/java"])
      });
    }
  